import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "offers_page" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "timer" }
const _hoisted_4 = {
  key: 0,
  class: "timeBox"
}
const _hoisted_5 = { class: "timeTitle" }
const _hoisted_6 = { class: "timer_countdown" }
const _hoisted_7 = {
  key: 0,
  style: {"margin-right":"25px"}
}
const _hoisted_8 = {
  key: 1,
  class: "timeBox"
}
const _hoisted_9 = { class: "timeTitle" }
const _hoisted_10 = { class: "timer_countdown" }
const _hoisted_11 = {
  key: 0,
  style: {"margin-right":"25px"}
}
const _hoisted_12 = { class: "promo_wrapper" }
const _hoisted_13 = { class: "promo_title" }
const _hoisted_14 = { class: "promo_title" }
const _hoisted_15 = { class: "promotion_card_list" }
const _hoisted_16 = { class: "bottom_text" }

import { useRouter } from 'vue-router';
import CustomHeader from '../../themeTwo/components/common/customHeader.vue';
import PromotionCard from './components/promotionCard.vue';
import { OffersView } from '@/view/offers/supportScript';


export default /*@__PURE__*/_defineComponent({
  __name: 'offersView',
  props: {
    dataSet: {}
  },
  setup(__props: any) {


const router = useRouter()
const props = __props


const getDayNameFromTimestamp = (timestamp: number): string => {
    const date = new Date(timestamp);
    return date.toLocaleDateString("en-US", { weekday: "long" });
}
const routerchangeHandle = () => {
    router.push('/')
    localStorage.setItem('footerPopupOpen', '3')
}

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('offers.depositReturn'),
      isPopupCloseBackIcon: true,
      onClosePopup: routerchangeHandle
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.dataSet.floatImage,
        alt: ""
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.dataSet.isActivityEnableTime)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('offers.remainTieTitle')), 1),
              _createElementVNode("div", _hoisted_6, [
                _createTextVNode(_toDisplayString(_ctx.dataSet.days > 0 ? _ctx.dataSet.days : ''), 1),
                (_ctx.dataSet.days > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('common.days')), 1))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.dataSet.hours), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('offers.hours')), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.dataSet.minutes), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('offers.minutes')), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.dataSet.seconds), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('offers.seconds')), 1)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('offers.untilStartPromoTitle')), 1),
              _createElementVNode("div", _hoisted_10, [
                _createTextVNode(_toDisplayString(_ctx.dataSet.days > 0 ? _ctx.dataSet.days : ''), 1),
                (_ctx.dataSet.days > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('common.days')), 1))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.dataSet.hours), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('offers.hours')), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.dataSet.minutes), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('offers.minutes')), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.dataSet.seconds), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('offers.seconds')), 1)
              ])
            ]))
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('offers.promotionTime')), 1),
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t(`offers.${getDayNameFromTimestamp(_ctx.dataSet.endTime)}`)), 1),
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.activityList, (item, index) => {
            return (_openBlock(), _createBlock(PromotionCard, {
              cardData: item,
              isActivityEnable: _ctx.dataSet.isActivityEnableTime,
              key: index,
              dayName: getDayNameFromTimestamp(_ctx.dataSet.endTime)
            }, null, 8, ["cardData", "isActivityEnable", "dayName"]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_van_row, { style: {"padding-bottom":"10px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "24",
              class: "title"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('common.activityTitle')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.activityIntro, (value) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "line_text",
            key: value
          }, _toDisplayString(value), 1))
        }), 128))
      ])
    ])
  ], 64))
}
}

})